module.exports = __webpack_public_path__ + "static/stake-pier-two-d8e1244da65a6be6b5064f1ab223da7c.jpg";